
import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

type InputType = 'select' | 'text' | 'number' | 'date' | 'textarea' | 'email' | 'password'

@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class AppInput extends Vue {
    @Prop() private type!: InputType
    @Prop() private length!: number
    @Prop() private prefix!: string
    @Prop() private color!: string
    @Prop() private label!: string
    @Prop() private value!: string
    @Prop() private hint!: string
    @Prop() private error!: string
    @Prop() private disabled!: boolean
    @Prop() private readonly!: boolean
    @Prop() private icon!: string
    @Prop() private selectOptions!: InputSelectOptionEntity[]
    @Prop({ default: '' }) private datalist!: string
    @Prop({ default: false }) private clearable!: boolean

    get backgroundColor() {
        return this.color ? this.color : '#FCFBFA'
    }

    get isEditing() {
        return (this.value && this.value !== '') || this.type === 'date'
    }

    get isDisabled() {
        return (
            (this.disabled !== undefined && this.disabled) ||
            (this.readonly !== undefined && this.readonly)
        )
    }

    get hasIcon() {
        return (this.icon !== undefined && this.icon !== '')
    }

    get hasError() {
        return this.error !== undefined && this.error !== ''
    }

    get hasHint() {
        return this.hint !== undefined && this.hint !== ''
    }

    get inputValue() {
        return (this.prefix !== undefined && this.prefix !== '' && !this.value.includes(this.prefix))
            ? this.prefix.concat(this.value)
            : this.value
    }

    get showDatalist() {
        return this.datalist !== '' && this.value && this.value.length > 2
    }

    public onEditInput(e: KeyboardEvent) {
        if (this.prefix !== undefined && this.prefix !== '') {
            const element = e.target as HTMLInputElement
            const start = element?.selectionStart ?? 0
            const keyCode = e.keyCode

            if ((keyCode > 39 || keyCode < 37) && (start <= this.prefix.length && keyCode === 8)) {
                e.preventDefault()
            }
        }
    }

    @Emit('input')
    public input(e: any) {
        return e.target.value
    }

    @Emit('onClickIcon')
    public onClickIcon(e: Event) {
        return e
    }

    @Emit('blur')
    public onBlur(e: Event) {
        return e
    }

    public focusInput() {
        (this.$refs.input as any).focus()
    }

    private onClear() {
        this.input({ target: { value: '' } })
    }
}
